import React from 'react';

import { IconButton, XCloseIcon } from '@metarouter-private/mr-mui';

import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

export default function EventDebuggerClearFiltersButton() {
  const { clearFilters } = useEventDebuggerTableContext();

  return (
    <IconButton onClick={clearFilters}>
      <XCloseIcon />
    </IconButton>
  );
}
